<template>
  <div class="table-action-wrapper d-flex flex-wrap align-items-center design-review" ref="container">
    <p class="item-selected m-0" v-html="`Selected: ${Object.keys(ids).length} ${Object.keys(ids).length > 1 ? 'items' : 'item'}`"></p>
    <a @click.prevent="submit" href="#" class="btn btn-outline-success d-flex align-items-center">
      <span>Confirm</span>
    </a>
    <a @click.prevent="downloadDesign" href="#" class="btn btn-outline-primary d-flex align-items-center ml-2">
      <span>Download</span>
    </a>
    <div class="position-relative d-flex w-100 mt-2 input-group">
      <textarea v-model="actionContent" class="form-control w-100"></textarea>
      <div class="input-group-append">
        <div class="input-group-text flex-column p-0">
          <a @click.prevent="handleAction('accept')" href="#" class="text-success flex-1 p-2">
            <span>Accept</span>
          </a>
          <a @click.prevent="handleAction('exclude')" href="#" class="text-danger flex-1 p-2">
            <span>Exclude</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import JSZip from 'jszip'
import { saveAs } from 'file-saver'
export default {
  data() {
    return {
      ids: {},
      actionContent: ''
    }
  },
  mounted() {
    let listStatus = this.store.getter('extra_attributes.status', {})
    let status = 'design-review'
    this.store.commit('query.status', {
      value: status,
      valueLabel: listStatus?.[status]?.text,
      fieldLabel: 'Status'
    })
    this.store.commit('more.blueprint', true)
    this.store.commit('cols.cb.hidden', false)
    this.$emit('change-filters', { search: '' }, { refresh: true, goToFirst: true })
    this.$emitter.on('table-list.refreshed', this.tableListRefreshed)
  },
  unmounted() {
    this.store.commit('more.blueprint', false)
    this.store.commit('cols.cb.hidden', true)
    this.$emitter.off('table-list.refreshed', this.tableListRefreshed)
  },
  computed: {
    store() {
      return this.config?.store
    },
    cb() {
      return this.config?.cb
    },
    rows() {
      let rows = {}
      Object.entries(this.store.getter('rows', {})).forEach(([indexRow, item]) => {
        rows[item._id] = item
        rows[item._id].indexRow = indexRow
      })
      return rows
    }
  },
  methods: {
    tableListRefreshed(e) {
      Object.entries(this.ids).forEach(([id]) => {
        e.cb[id] = true
      })
    },
    downloadDesign() {
      if (Object.keys(this.ids).length == 0) {
        alert('Design not selected yet!')
        return
      }

      let promise = []
      const zip = new JSZip()
      Object.entries(this.ids).forEach(([id, object]) => {
        promise.push(
          new Promise((resolve, reject) => {
            fetch(object.url, {
              method: 'GET'
            })
              .then((response) => response.blob())
              .then((blob) => {
                resolve({
                  name: object.name,
                  url: object.url,
                  id: id,
                  blob: blob
                })
              })
              .catch((error) => {
                reject(error)
              })
          })
        )
      })
      Promise.all(promise).then((values) => {
        values.forEach((value) => {
          if (!_.isUndefined(value.url)) {
            zip.file(`${value.name}.${this.$util.getExtensionFromString(value.url)}`, value.blob, {
              base64: true
            })
          }
        })
        zip.generateAsync({ type: 'blob' }).then(function (content) {
          saveAs(content, `Blueprint-${new Date().valueOf()}.zip`)
        })
      })
    },
    handleAction(action) {
      if (!confirm('Are you sure?')) {
        return
      }
      let list = this.actionContent.split('\n').map((item) => {
        return item.replace(/\s\s+/gi, ' ').trim().toUpperCase()
      })
      if (action == 'accept') {
        Object.entries(this.ids).forEach(([id, item]) => {
          if (list.indexOf(item.name) == -1) {
            delete this.ids[id]
          }
        })
      } else {
        Object.entries(this.ids).forEach(([id, item]) => {
          if (list.indexOf(item.name) != -1) {
            delete this.ids[id]
          }
        })
      }

      Object.entries(this.rows).forEach(([index, item]) => {
        if (this.ids[index] != undefined) {
          this.store.commit(['rows', item.indexRow, 'cb'], true)
        } else {
          this.store.commit(['rows', item.indexRow, 'cb'], false)
        }
      })
    },
    submit() {
      this.$util
        .post(
          'design/more/update-status',
          {
            ids: Object.keys(this.ids).join(','),
            status: 'mapping'
          },
          this.$refs.container
        )
        .then((response) => {
          if (response.status == 'success') {
            this.ids = {}
            this.actionContent = ''
            this.$emitter.emit('TableList.Refresh')
          }
        })
    }
  },
  watch: {
    cb: {
      handler(values) {
        Object.entries(values).forEach(([id, checked]) => {
          if (checked) {
            if (this.rows?.[id]?.design?.blueprint) {
              this.ids[id] = {
                name: this.rows?.[id]?.design?.name.replace(/\s\s+/gi, ' ').trim().toUpperCase(),
                url: this.rows?.[id]?.design?.blueprint
              }
            }
          } else if (this.ids[id] != undefined) {
            delete this.ids[id]
          }
        })
      },
      deep: true
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
.table-action-wrapper.design-review {
  .item-selected {
    width: 140px;
  }
  .input-group {
    a {
      width: 100%;
      &:hover {
        background: #d1eeff;
      }
    }
  }
}
</style>
